// src/pages/Overview.js
import React, { useState, useEffect } from 'react';
import overviewData from '../data/overview.json';
import { Card, CardContent } from '../components/ui/Card';

const Overview = () => {
  const { campaignName, overview } = overviewData;

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div
      style={{
        padding: '2rem',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '2rem',
        flexDirection: isMobile ? 'column' : 'row'
      }}
    >
      {/* Campaign Header Bar */}
      <Card style={{ width: '100%', backgroundColor: '#FFF' }}>
        <CardContent>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h2 style={{ margin: 0 }}>{campaignName}</h2>
            <p style={{ margin: 0, fontWeight: 'bold' }}>Status: Planning</p>
          </div>
        </CardContent>
      </Card>

      {/* Campaign Objective */}
      <Card style={{ flex: 1, minWidth: isMobile ? '100%' : '0' }}>
        <CardContent>
          <h3>Campaign Objective</h3>
          <p><strong>Objective:</strong> {overview.objective}</p>
          <p><strong>Primary Goal:</strong> {overview.primaryGoal}</p>
          <p><strong>Target Audience:</strong> {overview.targetAudience.role}</p>
          {overview.summary && (
            <p style={{
              whiteSpace: 'pre-line',
              fontStyle: 'normal',
              fontSize: '1.1rem',
              lineHeight: '1.6',
              color: '#444',
              marginTop: '0.5rem'
            }}>
              {overview.summary}
            </p>
          )}
        </CardContent>
      </Card>

      {/* Contacts & Stakeholders */}
      <Card style={{ flex: 1, minWidth: isMobile ? '100%' : '0' }}>
        <CardContent>
          <h3>Contacts</h3>
          {overview.brandAmbassador && (
            <>
              <h4>Brand Ambassador</h4>
              <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                <a
                  href={overview.brandAmbassador.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: 'none',
                    color: '#333',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem',
                    backgroundColor: '#f8f8f8',
                    padding: '0.75rem 1rem',
                    borderRadius: '8px',
                    minWidth: '240px'
                  }}
                >
                  <img
                    src={overview.brandAmbassador.photo}
                    alt={overview.brandAmbassador.name}
                    style={{ width: '48px', height: '48px', borderRadius: '50%', objectFit: 'cover' }}
                  />
                  <div>
                    <strong>{overview.brandAmbassador.name}</strong><br />
                    <span style={{ fontSize: '0.9rem', color: '#666' }}>
                      Microsoft MVP, Intune & Security Expert — {overview.brandAmbassador.channel}
                    </span>
                  </div>
                </a>
              </div>
            </>
          )}

          {overview.getRubixLead && (
            <div style={{ marginTop: '1.5rem' }}>
              <h4>GetRubix Campaign Lead</h4>
              <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                <a
                  href={overview.getRubixLead.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: 'none',
                    color: '#333',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem',
                    backgroundColor: '#f8f8f8',
                    padding: '0.75rem 1rem',
                    borderRadius: '8px',
                    minWidth: '240px'
                  }}
                >
                  <img
                    src={overview.getRubixLead.photo}
                    alt={overview.getRubixLead.name}
                    style={{ width: '48px', height: '48px', borderRadius: '50%', objectFit: 'cover' }}
                  />
                  <div>
                    <strong>{overview.getRubixLead.name}</strong><br />
                    <span style={{ fontSize: '0.9rem', color: '#666' }}>{overview.getRubixLead.title}</span>
                  </div>
                </a>
              </div>
            </div>
          )}

          {overview.stakeholders && (
            <div style={{ marginTop: '1.5rem' }}>
              <h4>Stakeholders</h4>
              <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                {overview.stakeholders.map((person, idx) => (
                  <a
                    key={idx}
                    href={person.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      textDecoration: 'none',
                      color: '#333',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.75rem',
                      backgroundColor: '#f8f8f8',
                      padding: '0.75rem 1rem',
                      borderRadius: '8px',
                      minWidth: '240px'
                    }}
                  >
                    <img
                      src={person.photo}
                      alt={person.name}
                      style={{ width: '48px', height: '48px', borderRadius: '50%', objectFit: 'cover' }}
                    />
                    <div>
                      <strong>{person.name}</strong><br />
                      <span style={{ fontSize: '0.9rem', color: '#666' }}>{person.title}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default Overview;